import { dataPointScalarValue } from '../../../../DataPoint/util';
import { Business, Loan, MonetaryAmount } from '../../../../generated/graphql';
import { addMonetaryAmounts, subtractMonetaryAmounts } from '../../../../util';

export const useBusinessEquity = (business: Business, loans: Loan[]) => {
  const loanBalances = loans.map((loan) => dataPointScalarValue(loan.balance.latestDataPoint?.data) as MonetaryAmount);

  return subtractMonetaryAmounts(dataPointScalarValue(business.value.latestDataPoint?.data) as MonetaryAmount, [
    addMonetaryAmounts(loanBalances),
  ]);
};
